
import React from "react";

interface EmptyStateMessageProps {
  viewMode: "active" | "archived";
  hasNotifications: boolean;
  hasFilteredResults: boolean;
}

const EmptyStateMessage = ({ viewMode, hasNotifications, hasFilteredResults }: EmptyStateMessageProps) => {
  if (!hasNotifications) {
    return (
      <tr>
        <td colSpan={7} className="h-24 text-center">
          {viewMode === "active" ? 
            "Geen actieve meldingen gevonden voor deze zoekcriteria" :
            "Geen gearchiveerde meldingen gevonden voor deze zoekcriteria"}
        </td>
      </tr>
    );
  }

  if (!hasFilteredResults) {
    return (
      <tr>
        <td colSpan={7} className="h-24 text-center">
          Geen meldingen gevonden met de geselecteerde filters
        </td>
      </tr>
    );
  }

  return null;
};

export default EmptyStateMessage;
